var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Residentials',{attrs:{"filter":_vm.filter,"project":_vm.project,"properties":_vm.properties,"title":_vm.$path('customFields.title-overrides.residentials', _vm.item)}})
}
var staticRenderFns = []

export { render, staticRenderFns }